angular.module('tgaAdmin')
  .service('languageService', ['$http', 'envService',
    function ($http, envService) {
      const serverAddress = envService.read('serverAddress');
      let languages = null;

      function getLanguages() {
        if (!languages) {
          languages = $http({
            method: 'GET',
            url: `${serverAddress}language`,
          }).then(
            (response) => response.data,
            (error) => {
              throw error.data;
            },
          );
        }

        return languages;
      }

      return ({
        getLanguages,
      });
    }]);
